// deps
import React from "react";
import { useIntl } from "react-intl";

// components
import { Row, Col } from "../../../Grid2";
import BookingDatePickerLegendElement from "./Element";

// constants
import {
  ROOM_AVAILABILITY_BACKGROUND_COLOR_VALUE_AVAILABLE_WITH_CONDITIONS,
  ROOM_AVAILABILITY_BACKGROUND_COLOR_VALUE_AVAILABLE_WITHOUT_CONDITIONS,
  ROOM_AVAILABILITY_BACKGROUND_COLOR_VALUE_BUSY,
} from "../../../../constants/room";

function BookingDatePickerLegend() {
  const intl = useIntl();

  return (
    <div>
      <Row maxColumns={3} gutter={0.25}>
        <Col>
          <BookingDatePickerLegendElement
            backgroundImage={`linear-gradient(to right bottom, ${ROOM_AVAILABILITY_BACKGROUND_COLOR_VALUE_AVAILABLE_WITHOUT_CONDITIONS} 50%, ${ROOM_AVAILABILITY_BACKGROUND_COLOR_VALUE_AVAILABLE_WITHOUT_CONDITIONS} 50%)`}
            text={intl.formatMessage({
              defaultMessage: "Jour disponible",
            })}
          />
        </Col>

        <Col>
          <BookingDatePickerLegendElement
            backgroundImage={`linear-gradient(to right bottom, ${ROOM_AVAILABILITY_BACKGROUND_COLOR_VALUE_AVAILABLE_WITH_CONDITIONS} 50%, ${ROOM_AVAILABILITY_BACKGROUND_COLOR_VALUE_AVAILABLE_WITH_CONDITIONS} 50%)`}
            text={intl.formatMessage({
              defaultMessage: "Disponible sous conditions",
            })}
          />
        </Col>

        <Col>
          <BookingDatePickerLegendElement
            backgroundImage={`linear-gradient(to right bottom, ${ROOM_AVAILABILITY_BACKGROUND_COLOR_VALUE_BUSY} 50%, ${ROOM_AVAILABILITY_BACKGROUND_COLOR_VALUE_BUSY} 50%)`}
            text={intl.formatMessage({
              defaultMessage: "Jour indisponible",
            })}
          />
        </Col>

        <Col>
          <BookingDatePickerLegendElement
            backgroundImage={`linear-gradient(to right bottom, ${ROOM_AVAILABILITY_BACKGROUND_COLOR_VALUE_BUSY} 49%, #d4d4d4 49%, #ffffff 51%, ${ROOM_AVAILABILITY_BACKGROUND_COLOR_VALUE_AVAILABLE_WITHOUT_CONDITIONS} 51%)`}
            text={intl.formatMessage({
              defaultMessage: "Arrivée possible",
            })}
          />
        </Col>

        <Col>
          <BookingDatePickerLegendElement
            backgroundImage={`linear-gradient(to right bottom, ${ROOM_AVAILABILITY_BACKGROUND_COLOR_VALUE_AVAILABLE_WITHOUT_CONDITIONS} 49%, #d4d4d4 49%, #ffffff 51%, ${ROOM_AVAILABILITY_BACKGROUND_COLOR_VALUE_BUSY} 51%)`}
            text={intl.formatMessage({
              defaultMessage: "Départ possible",
            })}
          />
        </Col>
      </Row>
    </div>
  );
}

export default BookingDatePickerLegend;
